import { CellContext } from '@tanstack/react-table';
import { formatNumber } from '@/utils/formatters.ts';
import { EmptyValue } from '@/components/ui/EmptyValue.tsx';

/**
 * Liczba z separatorem tysięcy. Zero jest wartością — pustką jest dopiero brak
 * liczby, więc `0` nie może wpaść do gałęzi „brak”.
 */
export const numberFieldRender = <T,>(info: CellContext<T, unknown>) => {
  const value = info.getValue();
  if (value === null || value === undefined || value === '') {
    return <EmptyValue />;
  }
  const parsed = typeof value === 'number' ? value : Number(value);
  if (Number.isNaN(parsed)) return <EmptyValue />;
  return formatNumber(parsed);
};
